export { default as PurpleCircle } from './purple-circle.svg'
